<template>
    <div class="d-flex flex-column">
<!--        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4"></div>-->
        <div class="row">
            <div class="col-12 col-xxl-8 mb-4">
                <div class="card border-0 shadow mb-4">
                    <div class="card-header border-bottom d-flex align-items-center justify-content-between">
                        <h2 class="fs-5 fw-bold mb-0">Curso</h2>
                    </div>
                    <div class="card-body">
                        <form>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <div>
                                        <label for="course_name">Nome</label>
                                        <input v-model="formDataCourses.course_name" class="form-control" id="course_name" type="text" placeholder="Assunto do curso" required>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label for="course_thumbnail" class="form-label">Imagem</label>
                                    <input class="form-control" id="course_thumbnail" type="file" accept="image/jpeg, image/png">
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div>
                                        <label for="course_description">Descrição</label>
                                        <textarea v-model="formDataCourses.course_description" class="form-control" id="course_description" type="text" placeholder="Descrição do curso" required></textarea>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="card border-0 shadow mb-4">
                    <div class="card-header border-bottom d-flex align-items-center justify-content-between">
                        <h2 class="fs-5 fw-bold mb-0">Edição</h2>
                    </div>
                    <div class="card-body">
                        <form>
                            <div class="row align-items-center">
                                <div class="col-md-5 mb-3">
                                    <label for="birthday">Inicio</label>
                                    <div class="input-group">
                                    <span class="input-group-text">
                                        <svg class="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path></svg>
                                    </span>
                                        <input data-datepicker="" class="form-control" id="birthday" type="text" placeholder="dd/mm/yyyy" required>
                                    </div>
                                </div>
                                <div class="col-md-5 mb-3">
                                    <label for="birthday">Termino</label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <svg class="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path></svg>
                                        </span>
                                        <input data-datepicker="" class="form-control" id="birthday" type="text" placeholder="dd/mm/yyyy" required>
                                    </div>
                                </div>
                                <div class="col-md-2 mb-3">
                                    <label for="birthday">Nº Vagas</label>
                                    <div class="input-group">
                                        <input class="form-control" id="vagas" type="text" required>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <button type="button" class="btn btn-outline-gray-500 d-inline-flex align-items-center justify-content-center dashed-outline w-100 hover-charcoal-gray">
                                        <svg class="icon icon-xs me-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                                        </svg> Adicionar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xxl-4 mb-4">
                <div class="card border-0 shadow">
                    <div class="card-header border-bottom d-flex align-items-center justify-content-between">
                        <h2 class="fs-5 fw-bold mb-0">Publicação</h2>
                        <a href="#" class="btn btn-sm btn-primary">Publicar</a>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-start">
                            <div class="text-muted">Status:&nbsp;</div>
                            <div class="d-md-block text-left" style="width: 160px">
                                <form class="form">
                                    <select class="form-select">
                                        <option value="1" selected="selected">Publicado</option>
                                        <option value="2">Pendente</option>
                                    </select>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Dashboard from "@/Layouts/Dashboard"

export default {
    layout: Dashboard,
    data() {
        return {
            formDataCourses: {
                course_name: '',
                course_thumbnail: '',
                course_description: '',
                course_code: '',
            },
            formDataClasses: {
                class_name: '',
                course_id: '',
                class_start_date: '',
                class_end_date: '',
                class_vacancy: '',
            }
        }
    }
}
</script>

<style scoped>
.hover-charcoal-gray:hover {
    background: #212529;
    border-style: solid;
}
</style>
